meedy.factory('meedy.resourceService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, baseService, objectHelper, config) {

        function ResourceService() {

            this.getDataPage = function (criteria) {
                return baseService.post(config.API_URL + '/resources/availableForLoggedUser', criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, ResourceMeedyVO);
                        return $q.resolve(dataPage);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getById = function (idResource) {
                return baseService.get(config.API_URL + '/resources/getById/' + idResource).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourceMeedyVO);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.save = function (resource) {
                return baseService.post(config.API_URL + '/resources/createOrUpdate', resource).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourceMeedyVO);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.delete = function (idResource) {
                return baseService.post(config.API_URL + '/resources/delete/' + idResource).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourceMeedyVO);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getResourcesAvailableForLoggedUser = function () {
                return baseService.get(config.API_URL + '/resources/listAvailableForLoggedUser').then(
                    function (successResponse) {
                        var data = objectHelper.translateArray(successResponse, ResourceMeedyVO);
                        var data = objectHelper.convertTimesToDates(data);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getPricelist = function (idResource) {
                return baseService.get(config.API_URL + '/resources/' + idResource + '/pricelist').then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourcePriceListMeedyVO);
                        var data = objectHelper.convertTimesToDates(data);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.saveOrUpdate = function (resourceWrapper) {
                return baseService.post(config.API_URL + '/resources/saveOrUpdateForAbc', resourceWrapper).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourceMeedyVO);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
        }

        return new ResourceService();
    }
]);
